/**
 * Chailease.SystemParameter.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { BankBranchSearchRequest } from '../model/bankBranchSearchRequest';
import { BankBranchSearchResponse } from '../model/bankBranchSearchResponse';
import { GetCodeResponseViewModel } from '../model/getCodeResponseViewModel';
import { NotificationSettingRequestViewModel } from '../model/notificationSettingRequestViewModel';
import { NotificationSettingResponseViewModel } from '../model/notificationSettingResponseViewModel';
import { ProcessRulesViewModel } from '../model/processRulesViewModel';
import { SystemDropDownListI18nViewModel } from '../model/systemDropDownListI18nViewModel';
import { SystemParameterRequestViewModel } from '../model/systemParameterRequestViewModel';
import { SystemParameterResponseViewModel } from '../model/systemParameterResponseViewModel';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class SystemParameterService {
  protected basePath =
    'http://ch-demo-apigw.chailease.com.tw/dev-backdoor/retail-system-parameter-service';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * [Public] 取得代碼表值
   *
   * @param codeTableCode
   * @param langcode
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterCodeTableCodeTableCodeLangcodeGetCodeGet(
    codeTableCode: string,
    langcode: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<GetCodeResponseViewModel>>;
  public commonSystemParameterCodeTableCodeTableCodeLangcodeGetCodeGet(
    codeTableCode: string,
    langcode: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<GetCodeResponseViewModel>>>;
  public commonSystemParameterCodeTableCodeTableCodeLangcodeGetCodeGet(
    codeTableCode: string,
    langcode: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<GetCodeResponseViewModel>>>;
  public commonSystemParameterCodeTableCodeTableCodeLangcodeGetCodeGet(
    codeTableCode: string,
    langcode: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (codeTableCode === null || codeTableCode === undefined) {
      throw new Error(
        'Required parameter codeTableCode was null or undefined when calling commonSystemParameterCodeTableCodeTableCodeLangcodeGetCodeGet.',
      );
    }

    if (langcode === null || langcode === undefined) {
      throw new Error(
        'Required parameter langcode was null or undefined when calling commonSystemParameterCodeTableCodeTableCodeLangcodeGetCodeGet.',
      );
    }

    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<GetCodeResponseViewModel>>(
      'get',
      `${this.basePath}/common/SystemParameter/CodeTable/${encodeURIComponent(String(codeTableCode))}/${encodeURIComponent(String(langcode))}/GetCode`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * [Public] 取得下拉選單
   *
   * @param code
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterCodeTableDropDownListGet(
    code?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<SystemDropDownListI18nViewModel>>;
  public commonSystemParameterCodeTableDropDownListGet(
    code?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<SystemDropDownListI18nViewModel>>>;
  public commonSystemParameterCodeTableDropDownListGet(
    code?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<SystemDropDownListI18nViewModel>>>;
  public commonSystemParameterCodeTableDropDownListGet(
    code?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (code !== undefined && code !== null) {
      queryParameters = queryParameters.set('code', <any>code);
    }

    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<SystemDropDownListI18nViewModel>>(
      'get',
      `${this.basePath}/common/SystemParameter/CodeTable/DropDownList`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * [Public] 取得下一層的下拉選單
   *
   * @param upcode
   * @param value
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterCodeTableDropDownListUpcodeGet(
    upcode: string,
    value?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<SystemDropDownListI18nViewModel>>;
  public commonSystemParameterCodeTableDropDownListUpcodeGet(
    upcode: string,
    value?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<SystemDropDownListI18nViewModel>>>;
  public commonSystemParameterCodeTableDropDownListUpcodeGet(
    upcode: string,
    value?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<SystemDropDownListI18nViewModel>>>;
  public commonSystemParameterCodeTableDropDownListUpcodeGet(
    upcode: string,
    value?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (upcode === null || upcode === undefined) {
      throw new Error(
        'Required parameter upcode was null or undefined when calling commonSystemParameterCodeTableDropDownListUpcodeGet.',
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (value !== undefined && value !== null) {
      queryParameters = queryParameters.set('value', <any>value);
    }

    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<SystemDropDownListI18nViewModel>>(
      'get',
      `${this.basePath}/common/SystemParameter/CodeTable/DropDownList/${encodeURIComponent(String(upcode))}`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * [Public] 依據類別取得系統參數清單
   *
   * @param body
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterEnquiryAllByTypePost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<SystemParameterResponseViewModel>>;
  public commonSystemParameterEnquiryAllByTypePost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<SystemParameterResponseViewModel>>>;
  public commonSystemParameterEnquiryAllByTypePost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<SystemParameterResponseViewModel>>>;
  public commonSystemParameterEnquiryAllByTypePost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<SystemParameterResponseViewModel>>(
      'post',
      `${this.basePath}/common/SystemParameter/EnquiryAllByType`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * [Public] 取得系統參數
   *
   * @param body
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterEnquiryPost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<SystemParameterResponseViewModel>;
  public commonSystemParameterEnquiryPost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<SystemParameterResponseViewModel>>;
  public commonSystemParameterEnquiryPost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<SystemParameterResponseViewModel>>;
  public commonSystemParameterEnquiryPost(
    body?: SystemParameterRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<SystemParameterResponseViewModel>(
      'post',
      `${this.basePath}/common/SystemParameter/Enquiry`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * 取得銀行及分行代碼相關資訊
   *
   * @param body
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterGetBankBranchCodesPost(
    body?: BankBranchSearchRequest,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<BankBranchSearchResponse>;
  public commonSystemParameterGetBankBranchCodesPost(
    body?: BankBranchSearchRequest,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<BankBranchSearchResponse>>;
  public commonSystemParameterGetBankBranchCodesPost(
    body?: BankBranchSearchRequest,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<BankBranchSearchResponse>>;
  public commonSystemParameterGetBankBranchCodesPost(
    body?: BankBranchSearchRequest,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<BankBranchSearchResponse>(
      'post',
      `${this.basePath}/common/SystemParameter/GetBankBranchCodes`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * [Public] 取得下拉選單
   *
   * @param code
   * @param userNo
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterCodeTableGetDealerRatingDropDownListByUserNoGet(
    code?: string,
    userNo?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<SystemDropDownListI18nViewModel>>;
  public commonSystemParameterCodeTableGetDealerRatingDropDownListByUserNoGet(
    code?: string,
    userNo?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<SystemDropDownListI18nViewModel>>>;
  public commonSystemParameterCodeTableGetDealerRatingDropDownListByUserNoGet(
    code?: string,
    userNo?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<SystemDropDownListI18nViewModel>>>;
  public commonSystemParameterCodeTableGetDealerRatingDropDownListByUserNoGet(
    code?: string,
    userNo?: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (code !== undefined && code !== null) {
      queryParameters = queryParameters.set('code', <any>code);
    }
    if (userNo !== undefined && userNo !== null) {
      queryParameters = queryParameters.set('userNo', <any>userNo);
    }

    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<SystemDropDownListI18nViewModel>>(
      'get',
      `${this.basePath}/common/SystemParameter/CodeTable/GetDealerRatingDropDownListByUserNo`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * [Public] Notification取得SmsOrEmail範本內容
   *
   * @param body
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterNotificationGetSmsOrEmailTemplatePost(
    body?: NotificationSettingRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<NotificationSettingResponseViewModel>;
  public commonSystemParameterNotificationGetSmsOrEmailTemplatePost(
    body?: NotificationSettingRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<NotificationSettingResponseViewModel>>;
  public commonSystemParameterNotificationGetSmsOrEmailTemplatePost(
    body?: NotificationSettingRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<NotificationSettingResponseViewModel>>;
  public commonSystemParameterNotificationGetSmsOrEmailTemplatePost(
    body?: NotificationSettingRequestViewModel,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<NotificationSettingResponseViewModel>(
      'post',
      `${this.basePath}/common/SystemParameter/Notification/GetSmsOrEmailTemplate`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * [Public] 取得RuleEngine規則
   *
   * @param workflowname
   * @param xFromChannel From Channel (Example: Web、APP...)
   * @param xClientTraceId Client side UUID
   * @param xServerTraceId Server side UUID
   * @param xClientDate Request time
   * @param xUserNo Request UserNo
   * @param xAuditInfo Use Audit Flow
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public commonSystemParameterProcessRulesWorkflowNameWorkflownameGet(
    workflowname: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<ProcessRulesViewModel>>;
  public commonSystemParameterProcessRulesWorkflowNameWorkflownameGet(
    workflowname: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<ProcessRulesViewModel>>>;
  public commonSystemParameterProcessRulesWorkflowNameWorkflownameGet(
    workflowname: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<ProcessRulesViewModel>>>;
  public commonSystemParameterProcessRulesWorkflowNameWorkflownameGet(
    workflowname: string,
    xFromChannel?: string,
    xClientTraceId?: string,
    xServerTraceId?: string,
    xClientDate?: string,
    xUserNo?: string,
    xAuditInfo?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (workflowname === null || workflowname === undefined) {
      throw new Error(
        'Required parameter workflowname was null or undefined when calling commonSystemParameterProcessRulesWorkflowNameWorkflownameGet.',
      );
    }

    let headers = this.defaultHeaders;
    if (xFromChannel !== undefined && xFromChannel !== null) {
      headers = headers.set('X-From-Channel', String(xFromChannel));
    }
    if (xClientTraceId !== undefined && xClientTraceId !== null) {
      headers = headers.set('X-Client-TraceId', String(xClientTraceId));
    }
    if (xServerTraceId !== undefined && xServerTraceId !== null) {
      headers = headers.set('X-Server-TraceId', String(xServerTraceId));
    }
    if (xClientDate !== undefined && xClientDate !== null) {
      headers = headers.set('X-Client-Date', String(xClientDate));
    }
    if (xUserNo !== undefined && xUserNo !== null) {
      headers = headers.set('X-UserNo', String(xUserNo));
    }
    if (xAuditInfo !== undefined && xAuditInfo !== null) {
      headers = headers.set('X-Audit-Info', String(xAuditInfo));
    }

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization'],
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ProcessRulesViewModel>>(
      'get',
      `${this.basePath}/common/SystemParameter/ProcessRules/WorkflowName/${encodeURIComponent(String(workflowname))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
